// The video editor (components/Editor), one file per area so its strings are
// written and reviewed in pieces: t('editor.rve.<area>.<key>')
import shell from './shell.en.js';
import text from './text.en.js';
import layers from './layers.en.js';
import timeline from './timeline.en.js';

export default { shell, text, layers, timeline };
